import Cookies from "universal-cookie";
import { menuFirsts, menuSeconds, menuThirds } from "../constants/menu";
import { STORAGE_KEY } from "./enum";
import _, { debounce } from "lodash";
import { decode } from "js-base64";

export const getToken = () => localStorage.getItem("TOKEN");

export const setToken = (value: string) => localStorage.setItem("TOKEN", value);

export const getRefreshToken = () => localStorage.getItem("REFRESH_TOKEN");

export const setRefreshToken = (value: string) => localStorage.setItem("REFRESH_TOKEN", value);

export const setOTPType = (value: any) => localStorage.setItem("OTP", value);

export const getOTPType = () => localStorage.getItem("OTP");

export const setProfile = (value: any) =>
  localStorage.setItem("PROFILE", JSON.stringify(value));

export const getProfile = (): any | IProfile => localStorage.getItem("PROFILE");

export const getPermissionMenus = () => getPermissions();

export const getPermissionActiveMenu = () =>
  _.get(getPermissions(), "activeMenu");

export const setBranch = (value: any) => localStorage.setItem("BRANCH", value);

export const getBranch = () => localStorage.getItem("BRANCH");

export const setApprove = (value: string) => localStorage.setItem("AP", value);

export const getApprove = () => localStorage.getItem("AP");

export const geteMenuNameNav = () => {
  const menu: any = localStorage.getItem("PERMISSION");
  let menuName = "";
  if (menu) {
    const { menuFirstKey, menuSecondKey, menuThirdKey } = JSON.parse(menu);
    menuName = menuSecondKey
      ? menuSeconds[menuSecondKey].textName
      : menuThirdKey
        ? menuThirds[menuThirdKey].textName
        : menuFirsts[menuFirstKey].textName;
  }
  return menuName;
};

export const logout = (): void => {
  localStorage.removeItem("BRANCH_ID");
  localStorage.removeItem("BRANCH");
  localStorage.removeItem(STORAGE_KEY.PROFILE);
  localStorage.removeItem(STORAGE_KEY.PERMISSION);
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("REFRESH_TOKEN");
  const cookies = new Cookies();
  cookies.remove("TOKEN");
  /** flag popup ผู้รับมรดกหมดอายุ (HeirExpiredAlert) — login ใหม่ต้องแสดงอีกครั้ง */
  try {
    Object.keys(sessionStorage)
      .filter((key) => key.startsWith("HEIR_ALERT_SHOWN_"))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    /* storage ถูกบล็อก */
  }
};

export const getPermissions = () => {
  const permissions: any = localStorage.getItem(STORAGE_KEY.PERMISSION);
  if (permissions) return JSON.parse(decode(permissions));

};

export const removeBranchStorage = () => {
  localStorage.removeItem("BRANCH_ID");
  localStorage.removeItem(STORAGE_KEY.PERMISSION);
};

export interface IProfile {
  userId: number;
  email: string;
  mobilePhone: string;
  roleId: number;
  firstname: string;
  lastname: string;
  roleName: string;
  customerId: number;
  empId?: any;
}

interface searchProps {
  searchItem: string;
  setItem: (value: string) => void;
}
/** ข้อความที่มาจากผู้ใช้/DB แล้วต้องใส่ใน html ของ swal — escape กัน HTML injection */
export const escapeHtml = (text?: string | null) =>
  String(text ?? '').replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' } as Record<string, string>)[ch]);

export const debouncedApiCall = debounce((props: searchProps) => {
  props.setItem(props.searchItem);
}, 400);


export const handleTypingNumber = (even: any) => {
  if (!/[0-9.]/.test(even.key)) {
    even.preventDefault();
  }
}

export const formatNumber = (n: any) => {
    return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export const formatCurrencyData = (value: string, mode: 'input' | 'convert' | 'revert', blur?: any): string | number | any => {
    if (!value.trim()) return '';
    switch (mode) {
        case 'input':
            if (value === '') {
                return '';
            }
            // if (value === '' || value.charAt(0) === "0") {
            //     return '';
            // }
            let inputVal = value;
            if (inputVal !== '0') {
                inputVal = inputVal.replace(/^0+/, '');
            }
            if (inputVal.indexOf('.') >= 0) {
                const decimalPos = inputVal.indexOf('.');
                const leftSide = inputVal.substring(0, decimalPos);
                const rightSide = inputVal.substring(decimalPos);

                inputVal = formatNumber(leftSide);

                if (blur === 'blur') {
                    inputVal += '00';
                }

                inputVal = `${inputVal}.${formatNumber(rightSide).substring(0, 2)}`;
            } else {
                inputVal = formatNumber(inputVal);

                if (blur === 'blur') {
                    inputVal += '.00';
                }
            }
            return inputVal;

        case 'convert':
            const numberRevert = value.replaceAll(',', '')
            return Number(numberRevert)

        case 'revert':
            const numericValue = parseFloat(value.replace(/,/g, ''));
            return numericValue.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');

        default:
            return value;
    }
};


export function dateAgo(
  createdDate: string | Date,
  en: boolean = false
): string {
  const now = new Date();
  const past = new Date(createdDate);

  // ตัดเวลาออก เหลือแค่ปี/เดือน/วัน
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const target = new Date(past.getFullYear(), past.getMonth(), past.getDate());

  const diffMs = today.getTime() - target.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays <= 0) {
    return en ? "today" : "วันนี้";
  }

  if (en) {
    return diffDays === 1
      ? "1 day ago"
      : `${diffDays} days ago`;
  }

  return `${diffDays} วันที่แล้ว`;
}


export function formatThaiMonthYear(dateStart: string | Date): string {
  const date = new Date(dateStart);

  const thaiMonths = [
    "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน",
    "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม",
    "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"
  ];

  const month = thaiMonths[date.getMonth()];
  const yearBE = date.getFullYear() + 543;

  return `ประจำเดือน${month}_${yearBE}`;
}